// File: client/src/components/rules/workflowDefaults.js

// Default initial nodes for a new workflow
const initialNodes = [
    {
        id: 'trigger-1',
        type: 'triggerNode',
        data: {
            label: 'Trigger',
            triggerType: 'callEvaluation',
            config: {
                type: 'callEvaluation',
                description: 'Triggered when a new call evaluation is completed'
            }
        },
        position: { x: 250, y: 50 }
    },
    {
        id: 'conditional-1',
        type: 'conditionalNode',
        data: {
            label: 'Quality Check',
            conditionType: 'javascript',
            config: {
                type: 'javascript',
                condition: 'record.qualScore < 70'
            }
        },
        position: { x: 250, y: 150 }
    },
    {
        id: 'action-1',
        type: 'actionNode',
        data: {
            label: 'Send Email',
            actionType: 'email',
            config: {
                type: 'email',
                template: 'default',
                subject: 'Low Quality Score Alert',
                body: '<p>A call has been evaluated with a low quality score:</p><p>Agent: <%= call.agentName %></p><p>Score: <%= call.qualScore %></p>',
                recipients: [
                    { email: 'supervisor@example.com', type: 'to' }
                ]
            }
        },
        position: { x: 100, y: 250 }
    },
    {
        id: 'complete-1',
        type: 'completeNode',
        data: {
            label: 'Complete',
            config: {
                type: 'complete',
                description: 'Workflow completed successfully'
            }
        },
        position: { x: 250, y: 350 }
    }
];

// Default initial edges for a new workflow
const initialEdges = [
    {
        id: 'edge-trigger-1-conditional-1',
        source: 'trigger-1',
        target: 'conditional-1',
        type: 'default',
        animated: false,
        style: { strokeWidth: 2 }
    },
    {
        id: 'edge-conditional-1-action-1',
        source: 'conditional-1',
        target: 'action-1',
        sourceHandle: 'true',
        type: 'default',
        animated: false,
        style: { strokeWidth: 2, stroke: '#22c55e' },
        label: 'True',
        labelStyle: { fill: '#22c55e', fontWeight: 'bold' }
    },
    {
        id: 'edge-conditional-1-complete-1',
        source: 'conditional-1',
        target: 'complete-1',
        sourceHandle: 'false',
        type: 'default',
        animated: false,
        style: { strokeWidth: 2, stroke: '#ef4444' },
        label: 'False',
        labelStyle: { fill: '#ef4444', fontWeight: 'bold' }
    },
    {
        id: 'edge-action-1-complete-1',
        source: 'action-1',
        target: 'complete-1',
        type: 'default',
        animated: false,
        style: { strokeWidth: 2 }
    }
];

// Default workflow configuration
export const defaultWorkflowConfig = {
    name: 'New Workflow',
    description: 'A new workflow',
    isActive: true,
    createdAt: new Date().toISOString(),
    updatedAt: new Date().toISOString(),
    nodes: initialNodes,
    edges: initialEdges
};
